// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a49c0f4a","239":"8af8e8ae","455":"418374e1"}[chunkId] + ".chunk.js";
};